import { Box, IconButton, Typography } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
const TotalDelete = ({ total, onDelete }) => {
  return (
    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
      <Typography color="text.secondary" fontSize={14}>
        Total to delete: {total}
      </Typography>
      <IconButton color="secondary" onClick={onDelete}>
        <DeleteForeverIcon color="error" />
      </IconButton>
    </Box>
  );
};
export default TotalDelete;
